import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 14, showValue = false, count }) => {
  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            size={size}
            className={
              i <= Math.round(value)
                ? "fill-[#D97706] text-[#D97706]"
                : "fill-transparent text-[#D6C9BA]"
            }
          />
        ))}
      </div>
      {showValue && <span className="text-xs font-semibold text-[#6B5B52]">{value.toFixed(1)}</span>}
      {count != null && <span className="text-xs text-[#9CA3AF]">({count})</span>}
    </div>
  );
};
